import { BaseRouteService } from 'core/services';

class LocalPatientRouteService extends BaseRouteService {
    constructor() {
        super('local-patients');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,fields,dateOfBirth,patientId,firstName,lastName}', filter);
    }

    get(id) {
        return super.get(this.base + '/{id}', id);
    }

    getByPatientKey(id) {
        return super.get(this.base + '/get-by-patient-key{id}', id);
    }

    create() {
        return super.create(this.base);
    }
    
    addLocalPatientFromBrightree(resource){
        return super.create(this.base + '/add-local-patient-from-bt', resource);
    }

}

export default LocalPatientRouteService;
